import {calendarDaysBetween,melbourneDate} from './dates';
export interface ReconnectSettings {enabled:boolean;window_days:number;last_run_at:number|null;last_result:string|null}
export interface DormantClient {
 id:string;name:string;status?:string;created_at:number;updated_at:number;do_not_contact:number;last_outreach_date:string|null;
 reconnect_last_created_at:number|null;last_delivered_date:string|null;active_projects:number;
 last_project_id:string|null;last_project_name:string|null;last_project_value:number|null;last_project_date:string|null;
 reconnect_task_id:string|null;outreach_touch_at?:number|null;
}
export function lastOutreachDate(client:Pick<DormantClient,'last_outreach_date'|'outreach_touch_at'>):string|null {
 return [client.last_outreach_date,client.outreach_touch_at?melbourneDate(client.outreach_touch_at):null].filter((v):v is string=>!!v).sort().at(-1)??null;
}
export function isDormant(client:Pick<DormantClient,'do_not_contact'|'created_at'|'active_projects'|'last_delivered_date'|'last_outreach_date'|'outreach_touch_at'>,today:string,days:number):boolean {
 if(client.do_not_contact||client.active_projects>0)return false;
 const baseline=melbourneDate(client.created_at);
 const touch=lastOutreachDate(client)??baseline;
 return calendarDaysBetween(client.last_delivered_date??baseline,today)>=days && calendarDaysBetween(touch,today)>=days;
}
export function sortDormant<T extends Pick<DormantClient,'id'|'name'|'last_project_date'>>(rows:T[],key:string,dir:'asc'|'desc'):T[]{
 return [...rows].sort((a,b)=>{
  const left=key==='name'?a.name:a.last_project_date??'',right=key==='name'?b.name:b.last_project_date??'';
  return (dir==='asc'?1:-1)*(left.localeCompare(right)||a.name.localeCompare(b.name)||a.id.localeCompare(b.id));
 });
}
